import { action, createRequestTypes } from './base';

export const uomActionTypes = {
  CREATE_UOM: createRequestTypes('CREATE_UOM'),
  GET_UOMS: createRequestTypes('GET_UOMS'),
  UPDATE_UOM: createRequestTypes('UPDATE_UOM'),
};

/**
 *
 */
class UomActions {
  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  createUom = (payload, callback) => action(uomActionTypes.CREATE_UOM.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param createUomLoading
   * @return {{type: *}}
   */
   createUomLoading = (createUomLoading) => action(uomActionTypes.CREATE_UOM.LOADING, {
     createUomLoading,
   })

  /**
   * @param orgId
   * @param page
   * @param limit
   * @param isActive
   * @param uomName
   * @return {{type: *}}
   */
  getUoms = (orgId, page, limit, isActive, uomName) => action(uomActionTypes.GET_UOMS.REQUEST, {
    orgId,
    page,
    limit,
    isActive,
    uomName,
  })

  /**
   *
   * @param getUomsLoading
   * @return {{type: *}}
   */
   getUomsLoading = (getUomsLoading) => action(uomActionTypes.GET_UOMS.LOADING, {
     getUomsLoading,
   })

  /**
   *
   * @param uoms
   * @return {{type: *}}
   */
  getUomsSuccess = (uoms) => action(uomActionTypes.GET_UOMS.SUCCESS, {
    uoms,
  })

  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  updateUom = (payload, callback) => action(uomActionTypes.UPDATE_UOM.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param updateUomLoading
   * @return {{type: *}}
   */
  updateUomLoading = (updateUomLoading) => action(uomActionTypes.UPDATE_UOM.LOADING, {
    updateUomLoading,
  })
}

export default new UomActions();
